import { render, staticRenderFns } from "./mustache-template.vue?vue&type=template&id=e223783c&scoped=true"
import script from "./mustache-template.vue?vue&type=script&lang=js"
export * from "./mustache-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e223783c",
  null
  
)

export default component.exports